import { newrelic } from "@jti/fe-clients";
import { getConfig } from "@jti/fe-common";

import { createLegacyApiWarningAttributes, getIsEvo, getUser } from "../../../utils";

import type { CasInvoiceApiContract } from "./CasInvoiceApi.types";
import { CasInvoiceApiEvo } from "./CasInvoiceApiEvo";
import { CasInvoiceApiLegacy } from "./CasInvoiceApiLegacy";

export class CasInvoiceApi {
  static init(): CasInvoiceApiContract {
    const config = getConfig();
    const user = getUser();

    if (config.USE_EVO_ONLY) {
      return CasInvoiceApiEvo.init();
    }

    if (getIsEvo(config.CAS_URL)) {
      return CasInvoiceApiEvo.init();
    }
    newrelic.sendWarning(
      "CasInvoiceApiLegacy initialized - legacy API client in use",
      createLegacyApiWarningAttributes(config, config.CAS_URL)
    );

    return new CasInvoiceApiLegacy(config.CAS_URL, config.CAS_X_DES_AK_TENANT_TOKEN, user.ciam_token, user.uuid ?? "");
  }
}
